import i18n from 'i18next'
import detector from 'i18next-browser-languagedetector'
import backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

i18n
	.use(detector)
	.use(backend)
	.use(initReactI18next)
	.init({
		fallbackLng: 'de',
		supportedLngs: ['de', 'en', 'tr', 'es', 'it', 'uk', 'cze', 'zh', 'ru', 'vi', 'fa', 'ar'],
		saveMissing: true,
		debug: false,
		detection: {
			order: ['localStorage', 'cookie', 'querystring'],
			lookupCookie: 'NEXT_LOCALE',
			caches: ['localStorage', 'cookie'],
		},
		// The prefix "No translation found for" is used by parseMissingKeyHandler to signal
		// missing translation keys so callers can fall back to raw enum values.
		parseMissingKeyHandler: (key) => {
			return `No translation found for "${key}"`
		},
		interpolation: {
			escapeValue: false,
		},
		backend: {
			loadPath: '/locales/{{lng}}/translation.json?v=' + (new Date()).getTime(),
		},
	})

export default i18n
